import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "../common/inputfunction";
import FontAwesome from "react-fontawesome";
import Permitlist from "./renderslip";
import Monthlist from "./rendermonthselect";
const Billdata = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  year,
  month,
  id,
  onDelete,
  error,
  size = "lg",
}) => {
  const [slipid, setslipid] = useState(0);
  const [confirmmessage, setconfirmmessage] = useState("");
  // const worklist = list.WorkerList;

  //console.log(list.length >0 && list[0]);
  const confirmDelete = (event) => {
    setslipid(event);
    setconfirmmessage("ท่านยืนยันที่จะลบรายการใช่หรือไม่");
  };
  const handleConfirmDelete = () => {
    onDelete(slipid);
    setconfirmmessage("");
  };

  // console.log(worklist)
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          {list && list.length > 0 && "รายละเอียดการโอนเงิน"}
          {"  "}{" "}
        </ModalHeader>
        <ModalBody>
          {list && list.length > 0 && (
            <Permitlist list={list} handleDelete={confirmDelete} />
          )}

          {!list && message}
        </ModalBody>

        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}
        {confirmmessage && (
          <div className="col-md-12 alert alert-danger"> {confirmmessage}</div>
        )}

        {confirmmessage && (
          <button
            className="btn btn-danger btn-sm m-1"
            onClick={handleConfirmDelete}
          >
            {"ยืนยัน"}
          </button>
        )}
        <ModalFooter>
 

          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Billdata;
